
const digest = 'dab09c713e7103da40ec154c8fbf27f23ca16fe3573e8c697b9b25c382ebcda9';
const classes = {"wrapper":"_wrapper_1mvyh_1"};
const css = `._wrapper_1mvyh_1 {
  background-color: #eaedf3;
  color: #3e3f42;
  padding: 11px 16px;
  border-radius: 19px;
  width: fit-content;
  font-size: 14px;
}
._wrapper_1mvyh_1:hover {
  cursor: pointer;
  background-color: #dfe1e8;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  